import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableScanPage = loadable(() => import('./ScanPage'), {
  fallback: <LoadingScreen />,
});

export default LoadableScanPage;
